import React from "react"
import PropTypes from "prop-types"
import { isFeatureEnabled } from "shared/featureflags/helperFunctions"

import { enumLabelSort, enumOrderSort } from "shared/search/containers/Filter/Filters"

import {
    enumGenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    AlertGroupFilterableListView,
    UserFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import { AlertGroupSelect, UserSelect } from "app/static/frontend/selects/containers/PieSelect"

const defaultPropTypes = {
    // required
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,
    // optional
    dataTypeLabel: PropTypes.string,
    displayLabel: PropTypes.string,
    enumItems: PropTypes.array,
    selectComponent: PropTypes.func,
    sortBy: PropTypes.func,
}

// toggle filters
export const AlertIsDefaultFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
AlertIsDefaultFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
AlertIsDefaultFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "alertIsDefaultFilter",
    filterKey: "default",
    displayLabel: "Created by Quorum",
    trueText: "Yes",
    falseText: "No",
}

// searchify filters
export const AlertCreatorFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter

    return <FilterComponent searchifyFLV={UserFilterableListView} {...props} />
}
AlertCreatorFilter.propTypes = defaultPropTypes
AlertCreatorFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "alertCreatorFilter",
    filterKey: "involving_alert_creator",
    selectComponent: UserSelect,
    dataTypeLabel: "Creator",
    displayLabel: "Creator",
}

export const AlertAlertGroupFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={AlertGroupFilterableListView} {...props} />
}
AlertAlertGroupFilter.propTypes = defaultPropTypes
AlertAlertGroupFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    filterKey: "underlying_alert_group",
    uniqueFilterId: "alertAlertGroupFilter",

    dataTypeLabel: "Alert Groups",
    selectComponent: AlertGroupSelect,
}

// enum filters
export const AlertDataTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
AlertDataTypeFilter.propTypes = defaultPropTypes
AlertDataTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    filterKey: "data_type__in",
    uniqueFilterId: "alertDataTypeFilter",

    displayLabel: "Data Type",
    enumItems: DjangIO.app.models.QuorumDataType.region_supported_items().filter((qdt) => qdt.supports_alert),
    sortBy: enumLabelSort,
}

export const AlertDeliveryMediumFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
AlertDeliveryMediumFilter.propTypes = defaultPropTypes
AlertDeliveryMediumFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    filterKey: "contains_media_type",
    uniqueFilterId: "alertDeliveryMediumFilter",

    displayLabel: "Delivery Medium Type",
    enumItems: DjangIO.app.userdata.alerts.types.DeliveryMedium.region_supported_items(),
    sortBy: enumLabelSort,
}

export const AlertFrequencyFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
AlertFrequencyFilter.propTypes = defaultPropTypes
AlertFrequencyFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    filterKey: "frequency__in",
    uniqueFilterId: "alertFrequencyFilter",

    displayLabel: "Frequency",
    enumItems: DjangIO.app.userdata.alerts.types.AlertFrequency.region_supported_items(),
    sortBy: enumOrderSort,
}

export const AlertUpdateTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
AlertUpdateTypeFilter.propTypes = defaultPropTypes
AlertUpdateTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    filterKey: "contains_update_type",
    uniqueFilterId: "alertUpdateTypeFilter",

    displayLabel: "Update Type",
    enumItems: DjangIO.app.userdata.alerts.types.NewUpdateType.region_supported_items(),
    sortBy: enumOrderSort,
}
